import Textarea from './Textarea';

export default Textarea;